var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ArticleTable',{staticClass:"drafts",attrs:{"heading":"Drafts","articles":_vm.drafts,"hide":['stage'],"date-label":"Created","date-field":"created_at"}})}
var staticRenderFns = []

export { render, staticRenderFns }